"use client"

import React, { useState, useEffect, useCallback } from "react"
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles"
import Slide from "@material-ui/core/Slide"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
// @material-ui/icons
import Close from "@material-ui/icons/Close"
// core components
import Button from "components/CustomButtons/Button.jsx"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import Snackbar from "components/Snackbar/Snackbar.jsx"
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx"
import Card from "components/Card/Card.jsx"
import Accordion from "components/Accordion/Accordion.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import GridContainer from "components/Grid/GridContainer.jsx"
import CartaProducto from "./CartaProducto"
import Cookies from "js-cookie"
import { useDesingStore } from "stores/desingStore"

const useStyles = makeStyles(modalStyle)

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})

const ModalTalla = ({ VerModal, EventoModalTalla, Producto, Tallas, CaracteristicasPorTalla, ProductosTallas }) => {
	if (!VerModal) return null
	const { Design, setDesign, setDesingState } = useDesingStore()
	const classes = useStyles()

	const [atributosAgregados, setAtributosAgregados] = useState([])
	const [caracteristicasAgregadas, setCaracteristicasAgregadas] = useState([])
	const [errorTalla, setErrorTalla] = useState(false)
	const [Origen, setOrigen] = useState("")
	const [tallasState, setTallasState] = useState([])
	const [colorNotificacion, setColorNotificacion] = useState("success")
	const [mensaje, setMensaje] = useState("")
	const [idTalla, setIdTalla] = useState("")
	const [productoState, setProductoState] = useState(null)
	const [br, setBr] = useState(false)

	// Función para manejar la tecla ESC
	const escFunction = useCallback(
		(event) => {
			if (event.keyCode === 27) {
				EventoModalTalla()
			}
		},
		[EventoModalTalla],
	)

	// Inicialización del componente
	useEffect(() => {
		console.log({ VerModal, EventoModalTalla, Producto, Tallas, CaracteristicasPorTalla, ProductosTallas })
		setTallasState(Tallas)
		setProductoState(Producto)
		setOrigen(Producto.Origen)

		CaracteristicasPorTalla.forEach((m) => {
			if (m.idTalla === idTalla) {
				setCaracteristicasAgregadas(m.caracteristicasAgregadas)
				setAtributosAgregados(m.atributosAgregados)
			}
		})
	}, [Tallas, Producto, CaracteristicasPorTalla, idTalla])

	// Agregar/remover event listener
	useEffect(() => {
		document.addEventListener("keydown", escFunction, false)
		return () => {
			document.removeEventListener("keydown", escFunction, false)
		}
	}, [escFunction])

	const handleChange = (event) => {
		const { value } = event.target
		setIdTalla(value)

		CaracteristicasPorTalla.forEach((m) => {
			if (m.idTalla === value) {
				setCaracteristicasAgregadas(m.caracteristicasAgregadas)
				setAtributosAgregados(m.atributosAgregados)
			}
		})
	}

	const showNotification = () => {
		setBr(true)
		setTimeout(() => {
			setBr(false)
		}, 3000)
	}

	const VerDiseñador3D = () => {
		if (idTalla !== "") {
			let encontrada = false

			ProductosTallas.forEach((f) => {
				if (f.Talla === idTalla) {
					encontrada = true
					let type = 0
					if (!Origen) {
						type = 1
					} else if (Origen === "Tienda") {
						type = 2
					}
					setDesingState({ type, idModel: f.idDiseno, idSize: idTalla })
				}
			})

			if (!encontrada) {
				const infotalla = ProductosTallas[0]
				let type = 0
				if (!Origen) {
					type = 1
				} else if (Origen === "Tienda") {
					type = 2
				}
				setDesingState({ type, idModel: infotalla.idDiseno, idSize: infotalla.idTalla })
			}

			window.location.href = "/diseñador3D"
		} else {
			setErrorTalla(true)
			setColorNotificacion("warning")
			setMensaje("Seleccione talla")
			showNotification()
		}
	}

	return (
		<div>
			<Dialog
				classes={{
					root: classes.modalRoot,
					paper: classes.modal + " " + classes.modalSignup,
				}}
				maxWidth="md"
				open={VerModal}
				TransitionComponent={Transition}
				keepMounted
				onClose={EventoModalTalla}
			>
				<Card plain className={classes.modalSignupCard}>
					<DialogTitle id="signup-modal-slide-title" disableTypography className={classes.modalHeader}>
						<Button
							simple
							className={classes.modalCloseButton}
							key="close"
							aria-label="Close"
							onClick={EventoModalTalla}
						>
							<Close className={classes.modalClose} />
						</Button>
						<center>
							<h3 className={`${classes.cardTitle} ${classes.modalTitle}`}>Selecciona la talla</h3>
						</center>
					</DialogTitle>
					<DialogContent>
						<GridContainer justify="center">
							<GridItem lg={5} md={5} sm={12} xs={12}>
								<CartaProducto Producto={productoState} />
							</GridItem>
							<GridItem lg={6} md={6} sm={12} xs={12}>
								<GridContainer>
									<GridItem lg={6} md={6} sm={7} xs={7}>
										<FormControl fullWidth className={classes.selectFormControl} error={errorTalla}>
											<InputLabel htmlFor="simple-select" className={classes.selectLabel}>
												Seleccione
											</InputLabel>
											<Select
												MenuProps={{ className: classes.selectMenu }}
												classes={{ select: classes.select }}
												value={idTalla}
												onChange={handleChange}
												inputProps={{ name: "idTalla", id: "idTalla" }}
											>
												<MenuItem disabled classes={{ root: classes.selectMenuItem }}>
													Seleccione
												</MenuItem>
												{tallasState.map((talla) => (
													<MenuItem
														key={talla._id}
														value={talla._id}
														classes={{
															root: classes.selectMenuItem,
															selected: classes.selectMenuItemSelected,
														}}
													>
														{talla.NombreTalla}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</GridItem>
									<GridItem lg={6} md={6} sm={5} xs={5}>
										<div style={{ marginTop: "1em", float: "right" }}>
											<Button size="sm" onClick={VerDiseñador3D} color="danger">
												Diseñar
											</Button>
										</div>
									</GridItem>
								</GridContainer>

								<GridContainer>
									<GridItem lg={12} md={12} sm={12} xs={12}>
										<Accordion
											active={0}
											activeColor="primary"
											collapses={[
												{
													title: "Características",
													content: (
														<div>
															{atributosAgregados.map((m, index) => (
																<div key={index}>
																	{m.NombreAtributo}:{" "}
																	{m.ValorDesplegable.length > 0 ? m.ValorDesplegable[0] : m.ValorColor}
																</div>
															))}
															{caracteristicasAgregadas.map((m, index) => (
																<div key={index}>
																	{m.NombreCaracteristica}: {m.ValorCaracteristica}
																</div>
															))}
														</div>
													),
												},
											]}
										/>
									</GridItem>
								</GridContainer>
							</GridItem>
						</GridContainer>
					</DialogContent>
				</Card>
				<Snackbar
					place="tc"
					color={colorNotificacion}
					message={mensaje}
					open={br}
					closeNotification={() => setBr(false)}
					close
				/>
			</Dialog>
		</div>
	)
}

export default ModalTalla
